// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		$( ".galleryModule" ).wrapAll( "<div class='wrapper' />");

		// SPECS ACCORDION
		document.querySelectorAll('.specsModule_item').forEach((item, i) => {
			item.querySelector('.specsModule_item-name').addEventListener('click', _ => {
				document.querySelectorAll('.specsModule_item').forEach((it, j) => { if ( i !== j ) it.classList.remove('active') });
				item.classList.toggle('active');
			});
		});

		// ADD CLOSE BTN TO MAIN NAV (TABLET)
		document.getElementById('primary-nav').insertAdjacentHTML('afterbegin', `<button class="js-toggle_nav privary-navigation-close" type="button">close</button>`);

		// TOGGLE MAIN NAV (TABLET)
		document.querySelectorAll('.js-toggle_nav').forEach(btn => {
			btn.addEventListener('click', _ => {
				document.getElementById('primary-nav').classList.toggle('active');
			});
		});

		// ROOMS FILTER
		document.querySelectorAll('.roomsFilter_item').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				$('.quad_slider').slick('unslick');

				document.querySelectorAll('.roomsFilter_item').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.room').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tags === 'all' || room.dataset.tags.includes(btn.dataset.tags) ) {
						room.classList.add('active');
					}
				});

				$('.quad_slider').slick( slickOptions );
			});

			if (i === 0) btn.click();
		});

		// ANIMATE SCROLL ANCHOR ON CLICK
		document.querySelectorAll('.js-anchorAnimate').forEach(btn => {
			const target = document.querySelector( btn.getAttribute('href') );
			btn.addEventListener('click', e => {
				e.preventDefault();
				if (target !== null) {
					$('html,body').stop().animate({ scrollTop: target.offsetTop }, 500);
				}
			});
		});

	});
 
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		document.getElementById('header').classList.add('scroll');
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		document.getElementById('header').classList.remove('scroll');
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}